import { Injectable } from '@angular/core';
import { ApiConnectorService } from '../__api/api-connector.service';
import { EventEmitterService } from './event-emitter.service';
import { FunctionsService } from './functions.service';

const MAX_ORDER_PROCESS_CHECKS = 20;

@Injectable({
  providedIn: 'root'
})
export class ResolverService {

  cache = {};
  loadingObj = {};
  orderProcessing = {};
  
  constructor(private apiConnector: ApiConnectorService,private eventEmitterService: EventEmitterService,private commonFunctions: FunctionsService) {
    // RESOLVER GETTING RESULT OBJECT
    if (this.eventEmitterService.subsVar==undefined) {    
      this.eventEmitterService.subsVar = this.eventEmitterService.    
      invokeFirstComponentFunction.subscribe((data:any) => {
        this.saveDataToLocalCache(data.cacheLabel,data.obj);
      });    
    }else{
      /* this.clientApps = this.resolver.getClientApps().records; */
    }
  }
    // DEPENDENCY RESOLVED
    saveDataToLocalCache(cacheLabel,data){
      this.cache[cacheLabel] = data;
    }

    clearCache(){
      this.cache = {};
      this.loadingObj = {};
      this.orderProcessing = {};
    }

    isLoading(cacheLabel){
      return this.loadingObj[cacheLabel];
    }

    // NEW FUNCTION TO SUSTITUIT ALL
    getBackendDataForQueryId(queryId,force,param1){

      if(queryId=='get' || queryId == 'GET'){
        this.loadingObj[param1] = true;
      }else{
        this.loadingObj[queryId] = true;
      }
      if(!force && this.cache[queryId]){
        this.loadingObj[queryId] = false;
        return this.cache[queryId];
      }else{
        this.apiConnector.newApiGetRequest(queryId,param1,null,null,null)
        .subscribe(
          (response) => {
              if(queryId=='get' || queryId == 'GET'){
                this.cache[param1] = response;
                // Use event emmiter
                this.eventEmitterService.onDependecyResolved(response,param1);
                this.loadingObj[param1] = false;
              }else{
                this.cache[queryId] = response;
                // Use event emmiter
                this.eventEmitterService.onDependecyResolved(response,queryId);
                this.loadingObj[queryId] = false;
              }
              },
          (error) => {
            this.loadingObj[queryId] = false;
            }
          );
      }
    }

    getDependency(cacheLabel){
      if(this.cache[cacheLabel]){
          return this.cache[cacheLabel];
      }else{
          return [];
      }
  }

    getClientInteractions(force){
      this.loadingObj['getInteractionXclient'] = true;
    if(!force && this.cache['getInteractionXclient']){
      this.loadingObj['getInteractionXclient'] = false;
      return this.cache['getInteractionXclient'];
    }else{
  
      this.apiConnector.voyjaleasApiRequest('getInteractionXclient','159',null,null,null,force)
      .subscribe(
        (response) => {
            this.cache['getInteractionXclient'] = response;
            // Use event emmiter
            this.eventEmitterService.onDependecyResolved(response,'getInteractionXclient');
            this.loadingObj['getInteractionXclient'] = false;
            },
        (error) => {
          this.loadingObj['getInteractionXclient'] = false;
          }
        );
      }
  
    }

    getDependencyRecords(queryLabel){
      if(this.getDependency(queryLabel) && this.getDependency(queryLabel).records){
        return this.getDependency(queryLabel).records;
      }else{
        return [];
      }
    }

    getProcessedChecklists(queryId,force,param1){

      if(queryId=='get' || queryId == 'GET'){
        this.loadingObj[param1] = true;
      }else{
        this.loadingObj[queryId] = true;
      }
      if(!force && this.cache[queryId]){
        this.loadingObj[queryId] = false;
        return this.cache[queryId];
      }else{
        this.apiConnector.newApiGetRequest(queryId,param1,null,null,null)
        .subscribe(
          (response) => {
            let ordered = this.commonFunctions.groupChecklists(response.records);
            this.cache[queryId] = ordered;
            // Use event emmiter
            this.eventEmitterService.onDependecyResolved(ordered,queryId);
            this.loadingObj[queryId] = false;
              },
          (error) => {
            this.loadingObj[queryId] = false;
            }
          );
      }
    }

    saveOrderStatus(orderId,newStatus){
      if(orderId){
        this.orderProcessing[orderId].status = newStatus;
      }
    }

    saveProcessingOrderData(orderId,data){
      if(orderId){
        this.orderProcessing[orderId] = data;
      }
    }

    __MAX_ORDER_PROCESS_CHECKS(){
      return MAX_ORDER_PROCESS_CHECKS;
    }

    async checkOrderStatus(orderId){
      let queryId = 'getOrderStatus';
      let apiURL;
      let queryParams = '?queryId='+queryId;
      orderId ? queryParams = queryParams + '&queryParam1=' + orderId : null;
      apiURL = this.apiConnector.getApiUrl('webapp') + queryParams;
  
      let data = await this.apiConnector.getXhr(apiURL).toPromise();

      //data && data['records']? this.saveOrderStatus(orderId,data['records'][0].status) : null;
      data && data['records']? this.saveProcessingOrderData(orderId,data['records'][0]) : null;
    }

    getOrderStatus(orderId){
      if(this.orderProcessing && this.orderProcessing[orderId]){
        return this.orderProcessing[orderId].status;
      }else{
        return null;
      }
    }

    getCurrentOrderData(orderId){
      if(this.orderProcessing && this.orderProcessing[orderId]){
        return this.orderProcessing[orderId];
      }else{
        return null;
      }
    }

    getMyOrders(){
      this.loadingObj['shopifyOrder'] = true;
      this.apiConnector.newApiGetRequest('get', 'shopifyOrder',null,null,null).subscribe(
        (response) => {
          this.saveDataToLocalCache('shopifyOrder',response.records)
          this.loadingObj['shopifyOrder'] = false;
            },
        (error) => {
          this.loadingObj['shopifyOrder'] = false;
          }
        );
    }

    getSelectedClientId(){
      return this.commonFunctions.getSelectedClientId();
    }

    getOrderToken(){
      return this.commonFunctions.getCurrentToken();
    }

}
